import { render, staticRenderFns } from "./modalReferencias.vue?vue&type=template&id=3e97768b&scoped=true&"
import script from "./modalReferencias.vue?vue&type=script&lang=js&"
export * from "./modalReferencias.vue?vue&type=script&lang=js&"
import style0 from "./modalReferencias.vue?vue&type=style&index=0&id=3e97768b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e97768b",
  null
  
)

export default component.exports